/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
const fieldDefaults = () => {
    return {
        width: 200,
    };
};
export function addFieldDefaults(field) {
    return {
        ...fieldDefaults(),
        ...field,
    };
}
export function initialiseFieldMeta() {
    return {
        data: {},
        order: {
            active: [],
            inactive: [],
        },
    };
}
